import { createContext, useContext, ReactNode } from "react";
import { PlanStoreInterface } from "../model/plan.types";
import { usePlanStore } from "../lib/plan.store";

const PlanContext = createContext<PlanStoreInterface | null>(null)

const PlanProvider = ({ children }: { children: ReactNode }) => {
  const store = usePlanStore();
  return(
    <PlanContext.Provider value={store}>
      {children}
    </PlanContext.Provider>
  )
}

const usePlanContext = () => {
  const ctx = useContext(PlanContext);
  if (!ctx) throw new Error("usePlanContext must be used within PlanProvider");
  return ctx
}

export { PlanProvider, usePlanContext }